import addDays from 'date-fns/addDays';
import addWeeks from 'date-fns/addWeeks';
import endOfWeek from 'date-fns/endOfWeek';
import isSunday from 'date-fns/isSunday';
import startOfWeek from 'date-fns/startOfWeek';
import subWeeks from 'date-fns/subWeeks';

export const startOfWeekLocale = (date: Date) => {
  const mondayBased = true;
  const startOfWeekNoLocale = startOfWeek(date);
  const mondayBasedStartOfWeek = addDays(startOfWeekNoLocale, 1);

  if (mondayBased && isSunday(date)) {
    return subWeeks(mondayBasedStartOfWeek, 1);
  }
  return mondayBased ? mondayBasedStartOfWeek : startOfWeekNoLocale;
};

export const endOfWeekLocale = (date: Date) => {
  const mondayBased = true;
  const startOfWeekNoLocale = startOfWeek(date);
  const endOfWeekNoLocale = endOfWeek(date);

  if (mondayBased && isSunday(date)) {
    return startOfWeekNoLocale;
  }
  return mondayBased ? addWeeks(startOfWeekNoLocale, 1) : endOfWeekNoLocale;
};
